import { UploadedFile } from '@vinnova/ui';
import { QuestionStructure } from './question-structure.model';

export interface QuestionStructureSignering extends QuestionStructure {
  // Direkt signering fields
  direktSigneringTitle: string;
  direktSigneringIntro: string;
  direktSigneringDescription: string;
  direktSigneringHandlingstyp: string;
  direktSigneringDokumentmall: string;

  // Manuell signering fields
  manuellSigneringTitle: string;
  manuellSigneringIntro: string;
  manuellSigneringDescription: string;
  manuellSigneringHandlingstyp: string;
  manuellSigneringDokumentmall: string;

  // Flerparts projekt signering (icke-MVP)
  flerpartsSigneringDescription: string;

  // Bilaga fields
  maxFileSize: number;
  maxNumberOfPages: number;
}

export const SigneringStructureName = {
  DirektSignering: {
    Title: 'direktSigneringTitle',
    Intro: 'direktSigneringIntro',
    Description: 'direktSigneringDescription',
    HandlingsTyp: 'direktSigneringHandlingstyp',
    Dokumentmall: 'direktSigneringDokumentmall',
  },
  ManuellSignering: {
    Title: 'manuellSigneringTitle',
    Intro: 'manuellSigneringIntro',
    Description: 'manuellSigneringDescription',
    HandlingsTyp: 'manuellSigneringHandlingstyp',
    Dokumentmall: 'manuellSigneringDokumentmall',
  },
  FlerpartsSignering: {
    Description: 'flerpartsSigneringDescription',
  },
} as const;

export enum SigneringTypeEnum {
  DirektSignering = 'DirektSignering',
  ManuellSignering = 'ManuellSignering',
  FlerpartsSignering = 'FlerpartsSignering',
}
export type SigneringType = keyof typeof SigneringTypeEnum;

export interface SigneringFormUpload extends UploadedFile {
  handlingstyp: string;
}
